import { render, staticRenderFns } from "./TextNumeric.vue?vue&type=template&id=1b54721c"
import script from "./TextNumeric.vue?vue&type=script&lang=js"
export * from "./TextNumeric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports